import React from 'react';

const DashboardPage = () => {
  return (
    <div style={{ padding: '40px' }}>
      <h1 style={{ color: '#3D3D3D' }}>Dashboard</h1>
    </div>
  );
};

export default DashboardPage;
